import { useState } from 'react';
import { Key, LogOut } from 'lucide-react';
import { useGenerateResetLink } from '../hooks';
import { ForceLogoutModal } from '../components/ForceLogoutModal';
import { DevicesTab } from './DevicesTab';
import type { AdminUserDetail } from '../types';

export function SecurityTab({ user }: { user: AdminUserDetail }) {
  const [showLogout, setShowLogout] = useState(false);
  const [link, setLink] = useState<string | null>(null);
  const resetLink = useGenerateResetLink();

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <button
          onClick={() => setShowLogout(true)}
          className="glass-panel rounded-xl p-4 flex items-center gap-3 hover:border-electric-violet text-left"
        >
          <LogOut className="w-5 h-5 text-electric-violet" />
          <div>
            <div className="font-bold text-sm">Force logout</div>
            <div className="text-[11px] text-on-surface-variant">Revoke all sessions and Firebase refresh tokens</div>
          </div>
        </button>
        <button
          onClick={async () => {
            try {
              const r = await resetLink.mutateAsync(user.id);
              setLink(r.link);
              await navigator.clipboard.writeText(r.link).catch(() => undefined);
            } catch (e) {
              alert((e as Error).message);
            }
          }}
          className="glass-panel rounded-xl p-4 flex items-center gap-3 hover:border-electric-violet text-left"
        >
          <Key className="w-5 h-5 text-electric-violet" />
          <div>
            <div className="font-bold text-sm">Generate password reset link</div>
            <div className="text-[11px] text-on-surface-variant">Link copied to clipboard on success</div>
          </div>
        </button>
      </div>

      {link && (
        <div className="glass-panel rounded-xl p-3 text-xs break-all">
          <div className="text-[10px] uppercase font-bold text-on-surface-variant mb-1">Reset link</div>
          {link}
        </div>
      )}

      <div>
        <h3 className="font-display font-bold mb-2">Sessions</h3>
        <DevicesTab userId={user.id} />
      </div>

      <ForceLogoutModal open={showLogout} userId={user.id} userName={user.name} onClose={() => setShowLogout(false)} />
    </div>
  );
}
